import React from "react";

import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import { useAuthContext } from "../../Context/AuthContext";
import { useCustomerUsers } from "./hooks";

interface Option {
  label: string;
  [key: string]: string;
}

interface DoerUserSelectorProps {
  onChange: (value: Option) => void;
  helperText?: string;
  error?: boolean;
}

export default function DoerUserSelector({
  onChange,
  helperText,
  error,
}: DoerUserSelectorProps): React.ReactElement | null {
  const { isDoitEmployee } = useAuthContext();
  const { t } = useTranslation("services");

  const options = useCustomerUsers();

  if (!isDoitEmployee) {
    return null;
  }

  return (
    <Autocomplete
      disableClearable
      options={options}
      onChange={(_, newValue: Option) => {
        onChange(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="medium"
          required
          label={t("DetailsStep.requester")}
          variant="outlined"
          helperText={helperText ?? ""}
          error={error}
        />
      )}
      data-cy="doer-user-selector"
    />
  );
}
